import { useEffect, useState } from 'react';
import { Input, Button, Collapse } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { postBalanceTransferReport } from '@src/store/slice/balanceUploadDetailSlice';
import { useDispatch, useSelector } from 'react-redux';
import CustomDatePicker from '@src/components/CustomDatePicker';
import { Text, useText } from '@src/components';

const { Panel } = Collapse;

const FilterMenu = ({ setFilteredText, filteredText, panels, listenClickCheckbox }) => {
  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const [activeKey, setActiveKey] = useState(['0']);
  const [sourceRefId, setSourceRefId] = useState();
  const [targetRefId, setTargetRefId] = useState();
  const [sourceCardNumber, setSourceCardNumber] = useState();
  const [targetCardNumber, setTargetCardNumber] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const filterMenuList = [
    {
      valueStart: startDate,
      valueEnd: endDate,
      setValueStart: setStartDate,
      setValueEnd: setEndDate,
      header: useText('balanceActiveDateRange'),
      headerStart: useText('startDate'),
      headerEnd: useText('endDate'),
      type: 'date',
      key: 'startDate'
    },
    {
      value: sourceRefId,
      setValue: setSourceRefId,
      header: useText('senderReferenceNo2'),
      type: 'text',
      key: 'sourceRefId'
    },
    {
      value: targetRefId,
      setValue: setTargetRefId,
      header: useText('recipientReferenceNo2'),
      type: 'text',
      key: 'targetRefId'
    },
    {
      value: sourceCardNumber,
      setValue: setSourceCardNumber,
      header: useText('sourceCardNumber'),
      type: 'number',
      key: 'sourceCardNumber'

    },
    {
      value: targetCardNumber,
      setValue: setTargetCardNumber,
      header: useText('targetCardNumber'),
      type: 'number',
      key: 'targetCardNumber'

    },
  ]

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const clickFilter = async () => {
    await dispatch(
      postBalanceTransferReport({
        customerId: selectedCustomer?.customerId,
        type: 1,
        sourceRefId,
        targetRefId,
        sourceCardNumber,
        targetCardNumber,
        startDate,
        endDate,
      }),
    );
  }

  const clearFilter = () => {
    setTargetCardNumber(null);
    setSourceCardNumber(null);
    setTargetRefId(null);
    setSourceRefId(null);
    setStartDate(null);
    setEndDate(null);
  }
  useEffect(() => {
    if (sourceRefId === null && targetRefId === null && sourceCardNumber === null && targetCardNumber === null && startDate === null && endDate === null) {
      clickFilter();
    }
  }, [sourceRefId, targetRefId, sourceCardNumber, targetCardNumber, startDate, endDate]);


  return (
    <div className="custom-filter-menu">
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <span className="custom-filter-menu-filtrele"><Text t="filter2" /></span>
        <button onClick={clearFilter} className="custom-filter-menu-clear">
          <Text t="clean" /></button>
      </div>
      <Collapse
        onChange={handleCollapseChange}
        activeKey={activeKey}
        expandIconPosition="right"
      >
        {filterMenuList.map((filter) => (
          <Panel
            key={filter.key}
            header={filter.header}
            className={
              activeKey?.filter((item) => item === filter.key).length > 0
                ? 'custom-demands-dropdown-item-active'
                : 'custom-demands-dropdown-item'
            }
          >{
              filter.type !== 'date' ? (
                <Input
                  id="demandsFilterSearch"
                  name="demandsFilterSearch"
                  type={filter.type}
                  placeholder={filter.header + ' Giriniz'}
                  prefix={<SearchOutlined />}
                  className="custom-filter-menu-search no-margin"
                  value={filter.value}
                  onChange={(e) => (filter.setValue(e.target.value))}
                />
              ) : (
                <>
                  <CustomDatePicker
                    height={36}
                    style={{ maringBottom: '12px' }}
                    placeholder={filter.headerStart}
                    value={startDate}
                    onChange={(value) => filter.setValueStart(value)}
                  />
                  <CustomDatePicker
                    height={36}
                    placeholder={filter.headerEnd}
                    value={endDate}
                    onChange={(value) => filter.setValueEnd(value)}
                  />
                </>
              )
            }
          </Panel>
        ))}
      </Collapse>
      <Button
        type="primary"
        onClick={clickFilter}
        block
        className="custom-filter-menu-filter-button"
      >
        <Text t="filter2" />
      </Button>
    </div>
  );
};

export default FilterMenu;

FilterMenu.propTypes = {
  setFilteredText: PropTypes.any,
  filteredText: PropTypes.string,
  panels: PropTypes.array,
  listenClickCheckbox: PropTypes.any,
};